import { type DropResult } from 'react-beautiful-dnd'
import { type ReactNode, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { CopyWrapper } from 'shared/ui'
import { DragAndDropSection } from 'shared/ui/DragAndDrop'
import type { ZIndex } from 'shared/constants/zIndex'
import { type IntegrationProperty } from 'entities/Integrations/model'
import { EmptyState } from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/shared/EmptyState'
import {
  type IItemRowProps,
  ItemRow,
} from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/shared/ItemRow/ItemRow'
import { DraggingItem } from 'widgets/ContactsDetails/ui/ContactsIntegrations/ui/DraggingItem/DraggingItem'
import styles from './styles.module.scss'

type IContactTabProps = {
  item?: {
    title: string
  }
  titleView: string
  properties: IntegrationProperty[]
  link: string
  integrationLabel: string
  titleEmpty: string
  actions?: ReactNode
  handleReorder?: (result: DropResult) => void
  handleClear?: (key: string) => void
  enableDnD?: boolean
  labelType?: IItemRowProps['labelType']
  zIndex?: ZIndex
}

export const SectionTab: FC<IContactTabProps> = observer(
  ({
    item,
    properties,
    link,
    integrationLabel,
    actions,
    titleView,
    titleEmpty,
    handleClear,
    handleReorder,
    enableDnD,
    labelType = 'simple',
    zIndex,
  }) => {
    if (!item) return <EmptyState>{titleEmpty}</EmptyState>

    const content = () => {
      if (enableDnD) {
        return (
          <DragAndDropSection
            droppableId={'contact-integration-properties'}
            onDragEnd={(result) => {
              handleReorder?.(result)
            }}
            items={properties}
            renderItem={(item, provided) => {
              return (
                <DraggingItem
                  dragHandleProps={provided.dragHandleProps}
                  hideDraggingIcon={false}
                  key={item.key}
                  content={
                    <ItemRow
                      key={item.key}
                      item={item}
                      clearAction={handleClear}
                      labelType={'field'}
                      zIndex={zIndex}
                    />
                  }
                />
              )
            }}
          />
        )
      }

      return (
        <div className={styles.companyWrapper}>
          {properties.map((property) => {
            return (
              <ItemRow
                key={property.key}
                item={property}
                clearAction={handleClear}
                labelType={labelType}
                zIndex={zIndex}
              />
            )
          })}
        </div>
      )
    }

    return (
      <div className={styles.contentWrapper}>
        <div className={styles.headerWrapper}>
          <CopyWrapper
            copyValue={item.title || titleView}
            clickableTitle
            data={{
              title: item.title || titleView,
              link: link,
              label: integrationLabel,
            }}
            zIndex={zIndex}
          />
        </div>
        {content()}
        {actions}
      </div>
    )
  }
)
